function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "16 13 12 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2a6.151 6.151 0 0 0-6 6.3C5 13.025 11 20 11 20s6-6.975 6-11.7A6.151 6.151 0 0 0 11 2Zm0 8.55A2.2 2.2 0 0 1 8.857 8.3 2.2 2.2 0 0 1 11 6.05a2.2 2.2 0 0 1 2.143 2.25A2.2 2.2 0 0 1 11 10.55Z",
    transform: "translate(11 11)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgLocationPin;